import { get } from 'lodash'

export const hasRole = (user = null, requiredRoles) => requiredRoles.includes(get(user, 'role'))
